// extracted by mini-css-extract-plugin
module.exports = {"fact":"fact___y8xlb","title":"title___3mSzB","description":"description___1ipwS","source":"source___pPN_9"};